import { useEffect } from "react";

export default function DimensionProperties() {
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    // تشغيل الوظيفة عند تحميل الصفحة
    setVh();

    // تحديث الـ vh عند تغيير حجم الشاشة
    window.addEventListener("resize", setVh);

    // إزالة الحدث عند التخلص من المكون
    return () => {
      window.removeEventListener("resize", setVh);
    };
  }, []);
}
